var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Form',{staticClass:"mt-2",attrs:{"form":_vm.meta.form}})}
var staticRenderFns = []

export { render, staticRenderFns }